import { ExoticComponent, useEffect, useState } from 'react';
import { WithPreloaderHOC } from '.';
import { Spinner } from './spinner/spinner';
import styles from './styles.module.scss';

export function withPreloader<P extends WithPreloaderHOC>(
	Component: React.ComponentType<P> | ExoticComponent,
	showError: boolean = true,
	Preloader: React.ComponentType = Spinner,
) {
	return (props: Omit<P, keyof WithPreloaderHOC> & WithPreloaderHOC) => {
		const [showPreloader, setShowPreloader] = useState(true);
		const { isLoading, error, ...restProps } = props;
		const isError = showError && error;

		useEffect(() => {
			let timer: NodeJS.Timeout;
			if (isLoading) {
				setShowPreloader(true);
			} else {
				timer = setTimeout(() => {
					setShowPreloader(false);
				}, 500);
			}

			return () => clearTimeout(timer);
		}, [isLoading]);

		return (
			<>
				{showPreloader ? (
					<Preloader />
				) : (
					!error && <Component {...(restProps as P)} />
				)}

				{isError && error.status === 404 ? (
					<div className={styles['error-text']}>
						Записи не найдены, попробуйте изменить параметры и
						попробовать еще раз
					</div>
				) : (
					isError && <div>Извините кажется произошла ошибка</div>
				)}
			</>
		);
	};
}
